import { AbstractEnum } from "./abstract-enum";

export class TaskManagementEventTypeEnum extends AbstractEnum {
  public static TASK = 1 as const;
  public static REMIND = 2 as const;
  public static HOLIDAY = 3 as const;
  public static LEAVE = 4 as const;
  public static OTHER = 5 as const;

  public static choices = {
    [TaskManagementEventTypeEnum.TASK]: "Task",
    [TaskManagementEventTypeEnum.REMIND]: "Reminder",
    [TaskManagementEventTypeEnum.HOLIDAY]: "Holiday",
    [TaskManagementEventTypeEnum.LEAVE]: "Leave",
    [TaskManagementEventTypeEnum.OTHER]: "Other",
  };
}

export type TaskManagementEventTypeEnumType =
  keyof typeof TaskManagementEventTypeEnum.choices;
